<template>
  <v-data-table
    :headers="headers"
    :items="correlationDischargeFormulaItems"
    sort-by="name"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat class="mb-5">
        <v-toolbar-title>{{
          $t("correlationToolDischarge.toolName")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title
              >{{ $t("safeDelete") }} {{ editedItem.name }}?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="red" text @click="deleteItemConfirm">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.fitting_algorithm="{ item }">
      {{ $t(`correlationTool.${item.fitting_algorithm}`) }}
    </template>
    <template v-slot:item.coefficients="{ item }">
      <span v-if="item.fitting_algorithm === 'exponential'">
        <p v-html="exponentialFormulaLabel(item.coefficients)" />
      </span>
      <span v-else>
        <p v-html="linearFormulaLabel(item.coefficients)" />
      </span>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
import analyseMixin from "@/core/mixins/analyse.mixin";

export default {
  name: "CorrelationData",
  mixins: [analyseMixin],
  data: () => ({
    search: "",
    dialogDelete: false,
    editedItem: {
      id: 0,
      name: "",
      fitting_algorithm: "",
      coefficients: []
    },
    defaultItem: {
      id: 0,
      name: "",
      fitting_algorithm: 0,
      coefficients: []
    }
  }),

  computed: {
    correlationDischargeFormulaItems: {
      get() {
        return this.$store.state.analyse.correlationDischargeFormulaItems;
      }
    },
    headers() {
      return [
        {
          text: this.$t("name"),
          align: "start",
          sortable: false,
          value: "name"
        },
        {
          text: this.$t("correlationTool.fitAlgorithm"),
          value: "fitting_algorithm"
        },
        { text: this.$t("correlationTool.formula"), value: "coefficients" },
        { text: "Actions", value: "actions", sortable: false }
      ];
    },
    deleteUrl() {
      return `/analyse/correlations-discharge/${this.editedItem.id}`;
    }
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    }
  },

  methods: {
    ...mapActions("analyse", ["fetchCorrelationDischargeFormulas"]),
    deleteItem(item) {
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await axios.delete(this.deleteUrl);
      await this.fetchCorrelationDischargeFormulas();
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
      });
    }
  }
};
</script>

<style scoped></style>
